export function RootEpics(SettingsEpics) {
  this.epic = SettingsEpics.epic;
}
